export default {
  childEditionListView: 'ap_child_edition_list_view',
  assignedChildEditionListView: 'ap_assigned_child_edition_list_view',
  childEditionView: 'ap_child_edition_view',
  assignedChildEditionView: 'ap_assigned_child_edition_view',
  coordinatorQuestionnaireAdd: 'ap_coordinator_questionnaire_add',
  documentCorrecting: 'ap_document_correcting',
  formsUpdatePrivileged: 'ap_forms_update_privileged',
  childEditionPublish: 'ap_child_edition_publish',
  paymentAccess: 'ap_payment_access',
  volunteerAssign: 'ap_volunteer_assign',
  childEditionRevokePublication: 'ap_child_edition_revoke_publication',
  childEditionChangeWioStruct: 'ap_child_edition_change_wio_struct',
  childEditionUpdate: 'ap_child_edition_update',
  updateTraditionalPayment: 'ap_update_traditional_payment',
  childEditionExclude: 'ap_child_edition_exclude',
  childEditionIncludeAgain: 'ap_child_edition_include_again',
  storyBeginningFormAdd: 'ap_story_beginning_form_add',
  assignedStoryBeginningFormAdd: 'ap_assigned_story_beginning_form_add',
  successCardAdd: 'ap_success_card_add',
  assignedSuccessCardAdd: 'ap_assigned_success_card_add',
  successCardView: 'ap_success_card_view',
  assignedSuccessCardView: 'ap_assigned_success_card_view',
  successCardCorrecting: 'ap_success_card_correcting',
  successCardAccept: 'ap_success_card_accept',
  documentView: 'ap_document_view',
  assignedDocumentView: 'ap_assigned_document_view',
  summaryCorrecting: 'ap_summary_correcting',
  contactWithGiftgiverAdd: 'ap_contact_with_giftgiver_add',
  assignedContactWithGiftgiverAdd: 'ap_assigned_contact_with_giftgiver_add',
  storySummaryFormAdd: 'ap_story_summary_form_add',
  assignedStorySummaryFormAdd: 'ap_assigned_story_summary_form_add',
  pastEditionChildView: 'ap_past_edition_child_view',
  coordinatorChildEditionListView: 'ap_coordinator_child_edition_list_view',
  coordinatorChildEditionDetailsView: 'ap_coordinator_child_edition_details_view',
  coordinatorQuestionnaireAdditionalView: 'ap_coordinator_questionnaire_additional_view',
  coordinatorQuestionnaireLinkView: 'ap_coordinator_questionnaire_link_view',
  dreamDrawingAdd: 'ap_dream_drawing_add',
  assignedDreamDrawingAdd: 'ap_assigned_dream_drawing_add',
  guardianConsentAudit: 'ap_guardian_consent_audit',
  peselViewAndEdit: 'ap_child_edition_pesel_view_and_edit',
  peselViewPastEdition: 'ap_past_edition_pesel_view',
  nextEditionRecommendationAdd: 'ap_next_edition_recommendation_add',
  nextEditionRecommendationAddCoordinator: 'ap_next_edition_recommendation_add_coordinator',
  nextEditionRecommendationView: 'ap_next_edition_recommendation_view',
  nextEditionRecommendationViewCoordinator: 'ap_next_edition_recommendation_view_coordinator'
} as const
